import React, { useCallback, useEffect, useState } from "react";
import { Header, DefaultSideBar, Text, Button } from "components";
import TableDetailRedeem from "components/TableEditRedeem";
import TableUpdateRedeem from "components/TableUpdateRedeem";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router";
import {
	changeStatusRedeem,
	detailRedeem,
	exportRedeem,
	submitRedeem,
	submitRedeemNew,
	updateBatch,
} from "services/redeem";
import { reportingsData } from "services/report";
import TableResumeRedeem from "components/TableResumeRedeem";
import * as loader from "../../components/Loading/loading";

export default function DetailRedeem() {
	const navigate = useNavigate();
	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const id = queryParams.get("id");

	const [data, setData] = useState(null);
	const [dataReport, setDataReport] = useState(null);
	const [selectedMaturity, setSelectedMaturity] = useState("");
	const [selectedFinancing, setSelectedFinancing] = useState("");
	const [selectedPool, setSelectedPool] = useState(null);
	const [blockedFinancing, setBlockedFinancing] = useState(null);
	const [totalReplacement, setTotalReplacement] = useState([]);
	const [submitError, setSubmitError] = useState("");
	const [customValues, setCustomValues] = useState([]);

	const fetchData = async () => {
		try {
			const redeemData = await detailRedeem(id);
			setData(redeemData.data);
			fetchDataAssets(redeemData.data.redeem_data.registration_id);
		} catch (error) {
			console.log("Error fetching batch data:", error);
		}
	};

	const fetchDataAssets = async (regId) => {
		if (regId) {
			try {
				const reportsData = await reportingsData(
					"",
					"",
					"",
					selectedMaturity,
					"",
					"",
					selectedFinancing,
					regId
				);
				setDataReport(reportsData.data);
			} catch (error) {
				console.error("Error fetching reporting data:", error);
			}
		}
	};

	useEffect(() => {
		fetchData();
	}, []);

	useEffect(() => {
		fetchDataAssets();
	}, [selectedMaturity, selectedFinancing]);

	const onCustomValue = useCallback((item) => {
		if (!customValues.length) {
			customValues.push(item);
			return;
		}

		setCustomValues(customValues.map(v => ({
			...v,
			poolValue: v.poolId === item.poolId ? item.poolValue : v.poolValue,
			ocValue: v.poolId === item.poolId ? item.ocValue : v.ocValue,
		})));
	}, customValues);

	const handleMaturityChange = (criteria) => {
		setSelectedMaturity(criteria.value);
	};

	const handleFinancingChange = (criteria) => {
		setSelectedFinancing(criteria.value);
	};

	const handleTotalReplacementChange = (criteria) => {
		const existingIndex = totalReplacement.findIndex(
			(item) => item.poolId === criteria.poolId
		);

		if (existingIndex !== -1) {
			const updatedTotalReplacement = [...totalReplacement];
			updatedTotalReplacement[existingIndex].totalReplacementAmount +=
				criteria.totalReplacementAmount;
			setTotalReplacement(updatedTotalReplacement);
		} else {
			setTotalReplacement([...totalReplacement, criteria]);
		}
	};

	const handleBlockedFinancingNo = (criteria) => {
		const newArray = blockedFinancing
			? [...blockedFinancing, ...criteria]
			: [...criteria];
		setBlockedFinancing(newArray);
	};

	const handleSelectedBatch = (criteria) => {
		const newSelectedPool = selectedPool ? [...selectedPool] : [];

		criteria.forEach((newItem) => {
			const existingIndex = newSelectedPool.findIndex(
				(item) => item.poolId === newItem.poolId
			);
			if (existingIndex !== -1) {
				newSelectedPool[existingIndex].data.push(newItem.data);
			} else {
				const groupPool = data.group_pool;
				const pool = groupPool.find(
					(item) => item.pool_id === newItem.poolId
				);
				const prevData = pool?.reportings;
				const prevFinancingAmount = pool?.total_financing_amount;
				newSelectedPool.push({
					...newItem,
					pool,
					poolId: newItem.poolId,
					data: [newItem.data],
					prevData,
					prevFinancingAmount,
				});
			}
		});

		setSelectedPool(newSelectedPool);
	};

	const handleReplaceBatch = () => {
		const allBatchesSelected = data.group_pool.every((batch) => {
			return selectedPool.some(
				(selected) => selected.poolId === batch.pool_id
			);
		});
		if (allBatchesSelected) {
			setSubmitError("");
			handleSubmitRedeem();
		} else {
			setSubmitError("Please select all batches before replacing.");
			return;
		}
		setSubmitError("");
	};

	// const handleSubmitRedeem = async () => {
	// 	loader.showLoader();
	// 	const dataRegId = data.redeem_data.registration_id;
	// 	const poolss = selectedPool.map(
	// 		({ poolId, prevData, pool, data }) => {
	// 			const batchingData = [];
	// 			prevData.forEach(({ financing_no }) => {
	// 				batchingData.push({ financing_no, status: "redeemed" });
	// 			});
	// 			data.forEach(({ financing_no }) => {
	// 				batchingData.push({ financing_no, status: "active" });
	// 			});
	// 			return {
	// 				id: poolId,
	// 				batch_id: pool.batch_id,
	// 				owner_id: pool.owner_id,
	// 				pooling_data: batchingData,
	// 			};
	// 		}
	// 	);

	// 	const redeemHistories = selectedPool.map(
	// 		({ poolId, data, prevData, prevFinancingAmount }) => {
	// 			const redeemHistories = {
	// 				pool_id: poolId,
	// 				updated_data: data,
	// 				previous_data: prevData,
	// 				previous_outstanding: prevFinancingAmount,
	// 				updated_outstanding: totalReplacement.find(
	// 					(replacement) => replacement.poolId === poolId
	// 				)?.totalReplacementAmount,
	// 				approved_time: new Date().toISOString(),
	// 				status: 'granted'
	// 			};
	// 			return redeemHistories;
	// 		}
	// 	);
	// 	const payload = {
	// 		registration_id: dataRegId,
	// 		poolings: poolss,
	// 		history_pools: {
	// 			redeem_id: id,
	// 			redeem_histories: redeemHistories
	// 		},
	// 	};
	// 	try {
	// 		const response = await submitRedeemNew(payload);
	// 		if (response) {
	// 			navigate(`/resume-redeem?id=${ id }`);
	// 		} else {
	// 			setSubmitError("Failed to redeem.");
	// 		}
	// 	} catch (error) {
	// 		setSubmitError(error);
	// 	} finally {
	// 		loader.hideLoader();
	// 	}
	// };
	console.log("selectedPool",
		selectedPool
	);
	const handleSubmitRedeem = async () => {
		loader.showLoader();

		const dataRegId = data.redeem_data.registration_id;
		const pools = selectedPool.map((item) => {
			const batchingData = [];
			item.prevData.forEach(({ financing_no }) => {
				batchingData.push({ financing_no, status: "redeemed" });
			});
			item.data.forEach(({ financing_no }) => {
				batchingData.push({ financing_no, status: "active" });
			});
			// TODO: update pool_value and oc_value from input number
			const customValue = customValues.find(v => v.poolId === item.pool.pool_id);
			const res = {
				...item.pool,
				id: item.pool.pool_id,
				pool_value: customValue && customValue.poolValue ? parseInt(customValue.poolValue) : item.pool.pool_value,
				oc_value: customValue && customValue.ocValue ? parseInt(customValue.ocValue) : item.pool.oc_value,
				pooling_data: batchingData,
			};
			delete res['pool_id'];
			delete res['financing_no'];
			delete res['total_financing_amount'];
			return res;
		});

		const redeemHistories = selectedPool.map(
			({ poolId, data, prevData, prevFinancingAmount, pool }) => {
				return {
					pool_id: poolId,
					updated_data: data,
					previous_data: prevData,
					previous_outstanding: prevFinancingAmount,
					updated_outstanding: totalReplacement.find(
						(replacement) => replacement.poolId === poolId
					)?.totalReplacementAmount,
					approved_time: new Date().toISOString(),
					original_funding_amount: pool.pool_value,
					oc_value: pool.oc_value
				};
			}
		);
		const payloadBatch = selectedPool.map(
			({ pool, data, prevData }) => {
				const batchingData = [];
				data.forEach(({ financing_no }) => {
					batchingData.push({ financing_no, status: "active" });
				});
				prevData.forEach(({ financing_no }) => {
					batchingData.push({ financing_no, status: "redeemed" });
				});
				return {
					registration_id: dataRegId,
					batch_id: pool.batch_id,
					batching_data: batchingData,
				};
			}
		);
		try {
			const updateBatchResponse = await updateBatch(Object.values(payloadBatch));
			if (!updateBatchResponse) {
				setSubmitError("Failed to update batch.");
				return;
			} else {
				const response = await submitRedeem(Object.values(pools));
				if (!response) {
					setSubmitError("Failed to submit redeem.");
					return;
				}
				try {
					const statusResponse = await changeStatusRedeem(id);
					if (!statusResponse) {
						setSubmitError("Failed to change status after redeem.");
						return;
					}
					const exportResponse = await exportRedeem(id, redeemHistories);
					if (exportResponse) {
						navigate(`/resume-redeem?id=${ id }`);
					} else {
						setSubmitError("Failed to export redeem histories.");
					}
				} catch (error) {
					setSubmitError("Error occurred during redeem status or export.");
				}
			}
		} catch (error) {
			setSubmitError("Error occurred during redeem submission or batch update.");
		} finally {
			loader.hideLoader();
		}
	};

	return (
		<div className=" w-full relative bg-gray-100 pl-[81px] pt-[10vh]">
			<Header />
			<DefaultSideBar />
			{ data && dataReport ? (
				<div className="flex flex-col gap-10">
					<div className="grid grid-cols-4 gap-10 px-10">
						<div className="flex flex-col items-start justify-start w-full mt-5 gap-7 h-[95vh] overflow-y-auto">
							{ data.group_pool.map((item, index) => (
								<TableDetailRedeem
									key={ index }
									data={ item }
									totalReplacement={
										totalReplacement.find(
											(replacement) => replacement.poolId === item.pool_id
										)?.totalReplacementAmount || 0
									}
								/>
							)) }
						</div>
						<div className="flex flex-col items-start justify-start w-full mt-5 gap-[17px] col-span-3">
							<TableUpdateRedeem
								data={ dataReport.reportings }
								poolOptions={ data.group_pool.map((item) => ({
									...item,
									poolId: item.pool_id,
									totalFinancing: item.total_financing_amount,
								})) }
								onFinancingChange={ handleFinancingChange }
								onMaturityChange={ handleMaturityChange }
								onReplaceBatch={ handleSelectedBatch }
								dataSelected={ selectedPool }
								dataCount={ selectedPool }
								setTotalReplacement={ handleTotalReplacementChange }
								totalReplacement={ totalReplacement }
								onBlockedFinancingNo={ handleBlockedFinancingNo }
								blockedFinancingNo={ blockedFinancing }
							/>
						</div>
					</div>
					<div className="flex flex-col items-start justify-start w-full px-10 mt-10">
						<TableResumeRedeem
							data={ selectedPool }
							totalReplacement={ totalReplacement }
							onChangValue={ onCustomValue }
						/>
					</div>
					{/* <div className="flex flex-col items-start justify-start w-full px-10 mt-10">
						<TableResumeBatch data={ dataCount } dataTotal={ data.group_pool } />
					</div> */}
					{ submitError && (
						<Text as="p" className="text-red-500 w-full justify-start px-10">
							{ submitError }
						</Text>
					) }

					<Button
						onClick={ handleReplaceBatch }
						disable={ data.redeem_data.status === "granted" }
						color="yellow_800"
						size="xl"
						className="!text-xl font-bold my-10 mx-80"
					>
						Submit Replace Pool
					</Button>
				</div>
			) : (
				<div className="flex w-full h-[90vh] justify-center items-center">
					Loading...
				</div>
			) }
		</div>
	);
}
